import React from 'react';
import { FILTERS } from './partnerHome';

export default function PartnerFilterTiles({ counts, value, onChange }) {
  return (
    <div className="ph-tiles" role="group" aria-label="Filter clients">
      {FILTERS.map((f) => (
        <button
          key={f.key}
          type="button"
          className={`ph-tile ${value === f.key ? 'ph-tile--active' : ''}`}
          aria-pressed={value === f.key}
          data-testid={`partner_filter_${f.key}`}
          onClick={() => onChange(f.key)}
        >
          <span className="ph-tile__label">{f.label}</span>
          <span className="ph-tile__count">{(counts && counts[f.key]) || 0}</span>
        </button>
      ))}
    </div>
  );
}
